/** Direcciones públicas e identificadores reservados de la instalación original. */
export const HOST_PUBLICO = 'rankealo.com.ar';
export const URL_PUBLICA = `https://${HOST_PUBLICO}`;
export const ID_ORIGINAL = 'marcos';
export const HOST_ORIGINAL = 'pericotes.rankealo.com.ar';
export const URL_ORIGINAL = `https://${HOST_ORIGINAL}`;
export const URLS_ORIGINAL_VALIDAS = [URL_PUBLICA, URL_ORIGINAL] as const;
export const IDS_RESERVADOS = [ID_ORIGINAL, 'pericotes'] as const;

export function esUrlOriginal(url: unknown): url is typeof URLS_ORIGINAL_VALIDAS[number] {
  return URLS_ORIGINAL_VALIDAS.some(permitida => permitida === url);
}
